import { configureStore } from '@reduxjs/toolkit';
import authReducer, { clearCredentials } from './authSlice';
import { setUnauthorizedHandler } from '@/lib/apiClient';

export const store = configureStore({
  reducer: {
    auth: authReducer,
  },
});

// On any 401 from the API client, drop the redux user + token so the app falls
// back to the Login screen. (The api client also clears localStorage itself.)
setUnauthorizedHandler(() => {
  store.dispatch(clearCredentials());
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
